import type { RefObject } from 'react';
import { useCallback, useEffect, useState } from 'react';
import { useDebounceCallback } from 'usehooks-ts';
const DEBOUNCE_TIME = 100;
export function useCanScroll(ref: RefObject<HTMLElement | null>) {
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const checkScrollable = useDebounceCallback(useCallback(() => {
    const current = ref.current;
    if (!current) return;
    const scrollLeft = current.scrollLeft;
    const scrollWidth = current.scrollWidth;
    const clientWidth = current.clientWidth;
    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft < scrollWidth - clientWidth);
  }, [ref]), DEBOUNCE_TIME);
  useEffect(() => {
    const current_0 = ref.current;
    if (!current_0) return;
    checkScrollable();
    current_0.addEventListener('scroll', checkScrollable);
    window.addEventListener('resize', checkScrollable);
    return () => {
      current_0.removeEventListener('scroll', checkScrollable);
      window.removeEventListener('resize', checkScrollable);
    };
  }, [checkScrollable, ref]);
  return {
    canScrollLeft,
    canScrollRight,
    checkScrollable
  };
}